import { useCallback } from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence } from 'framer-motion';

import AnimatedNotification from './AnimatedNotification';
import { Notification, useNotification } from './Notifications.store';

import styles from './Notifications.module.scss';

const Notifications = () => {
  const { notifications, close } = useNotification();

  const handleOnClose = useCallback(
    (notification: Notification) => {
      notification.options?.dismissOnClick && close(notification.id);
    },
    [close]
  );

  return createPortal(
    <div className={styles.container}>
      <AnimatePresence>
        {notifications.map(notification => (
          <AnimatedNotification key={notification.id} notification={notification} onClick={handleOnClose} />
        ))}
      </AnimatePresence>
    </div>,
    document.body
  );
};

export default Notifications;
